































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { CarrierProduct } from '@/modules/CarrierProduct/interfaces/carrier-product'
import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'
import {
  translateDocumentDeliveryKey,
  translateYesOrNoKey,
  translateLineOfBusinessCodeKey,
  translateQuoteViaKey,
  translateBindIssueViaKey
} from '@/utils/translate'

@Component({
  components: {
    FoldingCard,
    AppDialog,
    AppSystemInfoCard
  }
})
export default class CarrierProductDetailDetail extends Vue {
  @Prop({ type: Object as () => CarrierProduct }) readonly carrierProduct!: CarrierProduct

  productInfoCard = [
    { title: 'Carrier Downloads', content: '-' },
    { title: 'Quote Via', content: '-' },
    { title: 'Policy Document Delivery', content: '-' },
    { title: 'Billing Type', content: '-' },
    { title: 'Endorsement Document Delivery', content: '-' },
    { title: 'Bind / Issue Via', content: '-' }
  ]

  commissionInfoCard = [
    { title: 'New Bussiness Commission', content: '-' },
    { title: 'Renewal Commission', content: '-' }
  ]

  translateLineOfBusinessCodeKey = (key: string) => translateLineOfBusinessCodeKey(key)
  translateYesOrNoKey = (key: string) => translateYesOrNoKey(key)
  translateDocumentDeliveryKey = (key: string) => translateDocumentDeliveryKey(key)
  translateQuoteViaKey = (key: string) => translateQuoteViaKey(key)
  translateBindIssueViaKey = (key: string) => translateBindIssueViaKey(key)

  @Watch('carrierProduct', { deep: true })
  onCarrierProductUpdated (val: CarrierProduct) {
    this.productInfoCard[0].content = val.downloads ? this.translateYesOrNoKey(val.downloads) : '-'
    this.productInfoCard[1].content = val.quoteVia ? this.translateQuoteViaKey(val.quoteVia) : '-'
    this.productInfoCard[2].content = val.policyDocumentsDelivery ? this.translateDocumentDeliveryKey(val.policyDocumentsDelivery) : '-'
    this.productInfoCard[4].content = val.endorsementDocumentDelivery ? this.translateDocumentDeliveryKey(val.endorsementDocumentDelivery) : '-'
    this.productInfoCard[5].content = val.bindIssueVia ? this.translateBindIssueViaKey(val.bindIssueVia) : '-'

    this.commissionInfoCard[0].content = val.newBusinessCommission || '-'
    this.commissionInfoCard[1].content = val.renewalCommission || '-'
  }

  get carrierRoute () {
    return {
      name: 'CarrierDetailDetail',
      params: {
        id: this.carrierProduct.carrier.id
      }
    }
  }

  mounted () {
    this.onCarrierProductUpdated(this.carrierProduct)
  }
}
